import { render, staticRenderFns } from "./ResultDigitDisplay.vue?vue&type=template&id=9030a612&scoped=true&"
import script from "./ResultDigitDisplay.vue?vue&type=script&lang=js&"
export * from "./ResultDigitDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ResultDigitDisplay.vue?vue&type=style&index=0&id=9030a612&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9030a612",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
